module.exports = __webpack_public_path__ + "static/media/titlemainblue.bd23426e.png";